import { Alert, Button, Modal, Progress } from 'antd'
import type { CustomerSearchBatchStatus } from '@super-mega/server/contracts/customer'
import { getBatchJobAlertType, getBatchJobStatusLabel } from '@/utils/batch-job.ts'

export function CustomerBatchProgressModal({
  open,
  status,
  isError,
  onRetry,
  onClose
}: {
  open: boolean
  status?: CustomerSearchBatchStatus
  isError: boolean
  onRetry: () => void
  onClose: () => void
}) {
  const processed = status?.processed ?? 0
  const total = status?.total ?? 0
  const percent = total > 0 ? Math.round((processed / total) * 100) : 0
  let progressStatus: 'active' | 'normal' | 'success' | 'exception' = 'active'
  if (status?.state === 'completed') progressStatus = 'success'
  if (status?.state === 'completed' && status.failedCount > 0) progressStatus = 'exception'
  if (status?.state === 'failed') progressStatus = 'exception'
  if (status?.state === 'missing') progressStatus = 'normal'

  return (
    <Modal
      open={open}
      title="按搜索批量任务"
      width="34rem"
      destroyOnHidden
      onCancel={onClose}
      footer={<Button onClick={onClose}>关闭</Button>}
    >
      {isError ? (
        <Alert type="error" showIcon title="任务状态加载失败" action={<Button onClick={onRetry}>重试</Button>} />
      ) : (
        <div className="space-y-4">
          <Alert
            showIcon
            type={getBatchJobAlertType({
              state: status?.state,
              failedCount: status?.failedCount ?? 0,
              warningCount: 0,
              showFailureAsError: false
            })}
            title={`任务${getBatchJobStatusLabel(status?.state)}：${processed}/${total}`}
            description={`成功 ${status?.successCount ?? 0} 个，失败 ${status?.failedCount ?? 0} 个`}
          />
          <Progress percent={percent} status={progressStatus} />
          {status?.state === 'waiting' || status?.state === 'active' ? (
            <p className="text-content-muted m-0 text-sm">关闭窗口后任务会继续执行，可通过「查看批量任务」查看进度。</p>
          ) : null}
        </div>
      )}
      {status?.warnings.length ? (
        <ul className="text-content-muted mt-4 list-disc space-y-1 pl-5 text-sm">
          {status.warnings.map((warning, index) => (
            <li key={index}>{warning}</li>
          ))}
        </ul>
      ) : null}
    </Modal>
  )
}
